import { Spinner } from "@fluentui/react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UseTipoEquipoSync } from "./UseTipoEquipoSync";
import { Body1, Card, Title1 } from "@fluentui/react-components";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";

export const TipoEquipoSync = (props: IOpenPanel) => {
  const usePanel = UseTipoEquipoSync(props);
  const onRenderFooter = useCallback(
    () => (
      <>
        {usePanel.tipoEquipoSync.length!=0 && (
        <PanelFooter
          texto="Guardar"
          texto2={"Salir"}
          //disableButton={disableForm}
          onClick={usePanel.SyncronizarTipoEquipos}
          onDismiss={usePanel.reset}
        />)}
      </>
    ),
    [usePanel.tipoEquipoSync]
  );
  return (
    <PanelDrawer
      isOpen={props.isOpen}
      onDismiss={usePanel.reset}
      textHeader={"Tipo Equipos Encontradas a Sincronizar"}
      onRenderFooter={onRenderFooter}
      status={usePanel.status}
      mensaje={usePanel.mensaje}
      loading={usePanel.loading}
    >
      <br />
      {!usePanel.LoadingSincronizar ? (
        <>
          {usePanel.tipoEquipoSync.length == 0 ? (
            <Body1>
              Por el Momento, todos los tipos equipos ya han sido insertados
            </Body1>
          ) : (
            <>
              {usePanel.tipoEquipoSync.map((item: string, index: number) => (
                <Card>
                  <Title1>
                    {item}
                  </Title1>
                </Card>
              ))}
            </>
          )}
        </>
      ) : (
        <Spinner></Spinner>
      )}
    </PanelDrawer>
  );
};
